module.exports = {
	"articleTitle1": "Ann Arbor employees removed from Sava's restaurant by ICE ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Sava's",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/savas-follow",
	"articleSnippet1": "May 24, 2017 ... Three employees from Sava's restaurant on State Street were physically removed \nfrom the property by U.S. Immigration and Customs ...",
	"articleSnippet2": "May 26, 2017 ... Amid speculation and controversy, Sergio Cardenas Rubio — one of the three \nemployees of Sava's restaurant that was detained by ...",
	"foodRecommendations": [
		{
			"text": "I highly recommend the seared ribeye. It's mighty expensive, but it's sooo good.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Following incident at Sava's, two employees released and one still ...",
	"address": "216 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/eyx.NEW_.Sava%27s.4.1.16.029.jpg?itok=jOkwiMhJ",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279681,
		"lng": -83.741178
	},
	"totalMisc": 2,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"datespot": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/savas.json
// module id = 967
// module chunks = 0